import React, { useContext, useEffect, useState } from 'react'
import Icons from '../../components/Icons';
import { Context } from "../contexts/AppContext";

function Uploadvideo(props) {
    let [videoFile, setVideoFile] = useState([]);
    
    const [uploadStatus, setUploadStatus] = useState('');
    const [counter, setCounter]=useState(0)

     const { value } = useContext(Context);
    const [appState, setAppState] = value; 
  const {currentFolderName, currentGalleryName}=appState;

  

 
    const handleFileChange = (event) => {
        console.log(event.target.files)
        const files = event.target.files; // FileList object
        const fileArray = Array.from(files); // Convert to an array if needed
        setVideoFile(fileArray)
        videoFile=fileArray
        handleUpload()
      };
    
    
      const getPresignedUrl = async (file) => {
    
        var folderPath= `${currentFolderName}/${currentGalleryName}`;
        console.log("folderPath=== ",folderPath)
        var presignedApi = `http://localhost:5001/products/generate-presigned-url?folderPath=${folderPath}&fileName=${file.name}&fileType=${file.type}`;
        const response = await fetch(presignedApi, {
          method: "POST",  // POST method
          headers: {
              "Content-Type": "application/json" // send JSON Data
          },
          body: JSON.stringify({
              "file_name": `${currentFolderName}/${currentGalleryName}`,
          })
      });
    
      return response.json();
      }
    
      const handleUpload = async () => {
        try {
            // Step 1: Generate presigned URLs for all videos
            const presignedUrls = await Promise.all(
                videoFile.map(async (file) => {
                    const data = await getPresignedUrl(file);
                    const { upload_url } = JSON.parse(data.body);
                    return upload_url;
                })
            );
    
            // Step 2: Upload videos one by one
            for (let index = 0; index < videoFile.length; index++) {
                const upload_url = presignedUrls[index];
                const file = videoFile[index];
    
                await new Promise((resolve, reject) => {
                    const xhr = new XMLHttpRequest();
                    xhr.open("PUT", upload_url, true);
    
                    // **Upload Progress Track**
                    xhr.upload.onprogress = function (event) {
                        if (event.lengthComputable) {
                            const percentComplete = (event.loaded / event.total) * 100;
                            props.showProgressBar(file.name, Math.round(percentComplete));
                        }
                    };
    
                    // **Upload Success**
                    xhr.onload = function () {
                        if (xhr.status === 200) {

                            console.log("File Uploaded Successfully ",index);
                           // if(index>=videoFile.length-1)
                            {
                              props.videoUploadedDone(videoFile[index]);
                            }
                            
                            resolve(); // Resolve only when the upload is successful


                        } else {
                            console.error("Upload failed with status:", xhr.status);
                            alert("Problem with upload");
                            reject(new Error("Upload failed"));
                        }
                    };
    
                    // **Upload Error Handle**
                    xhr.onerror = function () {
                        console.log("Network error. Please try again");
                        reject(new Error("Network error"));
                    };
    
                    // Sending the video file for upload
                    xhr.send(file);
                });
    
                console.log(`Upload complete for file: ${file.name}`);
            }
        } catch (error) {
            console.error("Error during upload:", error);
        }
    };
    
      
      const deleteFileFromS3 = async (fileName) => {
    
        console.log('filename ',fileName)
        const requestData = {
          bucketName: 'sv-dest-bucket',  // Replace with your bucket name
          fileName: fileName,             // File path (e.g., 'radhey/shyam/hakka-pos.mp4')
        };
    
    
        try {
          const response = await fetch(`${process.env.REACT_APP_API_PATH}/products/delete-file`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({fileName: fileName}),
          });
      
          const data = await response.json();
          alert(data.message);
        } catch (error) {
          console.error("Error deleting file:", error);
        }
      };
  
  return (
    <div className='flex flex-col
 items-center mt-72'>
          {videoFile.length>0 && <img src="/img/spinner.gif" alt="spinner" style={{width:"120px", padding:"10px"}}/>}
        <input
        type="file"
        accept="video/*"
        multiple
        onChange={handleFileChange}
        id="fileInput"
        style={{ display: "none" }}
      />
        
    <button     onClick={() => document.getElementById("fileInput").click()}className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded flex gap-2 m-auto my-auto">
     <Icons.Uploads /> Upload Videos
    </button>
    </div>
  )
}

export default Uploadvideo